import React from "react";
import OrderCounts from "../../components/Asbeza/OrderCounts";

const OrderCountsPage = () => {
  return <OrderCounts />;
};

export default OrderCountsPage;
